/* eslint-disable no-unused-vars */
import { Box } from '@mui/material';
import { InvestorTypeHeader } from '../../../../components/investorTypeHeader';
import { useContext, useEffect, useState } from 'react';
import { InvestorType, isCorporateType } from '../../../../../../constants/investorType';
import { PersonalInfoGlobal } from './personalInfoGlobal';
import { PersonalInformationExtra } from '../../personalInformationExtra';
import { InvestorBusinessInformation } from '../../businessInformation/global';
import { useSearchParams } from 'react-router-dom';
import { getRegistrationData } from '../../../../../../services/authService';
import { resetParam, setURLParam } from '../../../../../../helpers/setParamUrlHelper';
import { RegistrationURLSteps } from '../../../../../../constants/registrationURLStep';
import { IS_SA } from '../../../../../../config/appConfig';
import { OpenPanelCategories, OpenPanelEvents } from '../../../../../../constants/openPanelEvents';
import { trackOpenPanel, identifyOpenPanel } from '../../../../../../helpers/openPanelHelper';
import { trackCustomerIo, identifyCustomerIo } from '../../../../../../helpers/customerIoHelper';
import { getUser } from '../../../../../../services/authService';
import { InvestorStepperContext } from '../../../../../../context/investorStepperContext';

const FormSubSteps = {
	personalInfo: 1,
	businessOrExtra: 2,
};

export const PersonalInfoGlobalIndex = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [activeType, setActiveType] = useState(null);
	const [currentStep, setCurrentStep] = useState(FormSubSteps.personalInfo);
	const [isBack, setIsBack] = useState(false);
	const { isKsaInternationalInvestor } = useContext(InvestorStepperContext);

	const isCorporate = () => {
		return isCorporateType(activeType?.name);
	};

	const onTop = () => {
		window.scrollTo({
			behavior: 'smooth',
			top: 0,
			left: 0,
		});
	};

	useEffect(() => {
		let step = searchParams.get('step');
		const regStep = getRegistrationData()?.step;
		if (
			step &&
			!isNaN(parseInt(step)) &&
			parseInt(step) <= 2 &&
			regStep === 2
		) {
			setCurrentStep(parseInt(step));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const removeParams = () => {
		if (searchParams.has('step')) {
			searchParams.delete('step');
			setSearchParams(searchParams);
		}
	};

	return (
		<Box>
			<InvestorTypeHeader
				isBack={isBack}
				onSelectInvestorType={(type) => {
					setIsBack(false);
					setActiveType(type);
				}}>
				{currentStep === FormSubSteps.personalInfo ? (
					<PersonalInfoGlobal
						onBack={() => {
							resetParam();
							setURLParam('currentStep', RegistrationURLSteps.investorType);
							setIsBack(true);
						}}
						investorType={activeType}
						onSubmit={(nationalityId, countryId, firstName, lastName) => {
							trackOpenPanel(OpenPanelEvents.personalInformationCompleted, {
								category: OpenPanelCategories.kyc,
							});
							trackCustomerIo(OpenPanelEvents.personalInformationCompleted, {
								category: OpenPanelCategories.kyc,
							});
							const nameTraits = {
								...(firstName ? { first_name: firstName } : {}),
								...(lastName ? { last_name: lastName } : {}),
							};
							identifyOpenPanel(getUser(), nameTraits);
							identifyCustomerIo(getUser(), nameTraits);
							onTop();
							setCurrentStep(FormSubSteps.businessOrExtra);
							setURLParam({
								currentStep: RegistrationURLSteps.personalInfoExtra,
								c: countryId
							});
						}}
					/>
				) : currentStep === FormSubSteps.businessOrExtra ? (
					!isCorporate() ? (
						<PersonalInformationExtra
							onGoBackKSA={() => {
								setIsBack(true);
							}}
							isSa={IS_SA && !isKsaInternationalInvestor}
							onGoBack={() => {
								resetParam();
								removeParams();
								setURLParam('currentStep', RegistrationURLSteps.personalInfo);
								onTop();
								setCurrentStep(FormSubSteps.personalInfo);
							}}
						/>
					) : (
						<InvestorBusinessInformation
							onGoBack={() => {
								removeParams();
								onTop();
								setCurrentStep(FormSubSteps.personalInfo);
							}}
						/>
					)
				) : null}
			</InvestorTypeHeader>
		</Box>
	);
};
